import DsInput from './src/input';

/* istanbul ignore next */
DsInput.install = function(Vue) {
    Vue.component(DsInput.name, DsInput);
};

export default DsInput;
